<template>
  <v-dialog
    v-model="showDialog"
    max-width="400"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mx-2"
        v-bind="attrs"
        v-on="on"
        :disabled="buttonDisabled"
      >
        <v-icon>
          mdi-plus
        </v-icon>
        add new image
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Upload image</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-file-input
                v-model="file"
                :loading="loading"
                :disabled="disabled"
                accept=".png, .jpg"
                label="Click here to upload image"
              />
            </v-col>
          </v-row>
          <v-row>
            <DataList
              :item-model.sync="author_id"
              :type-object="$constants.DATA_LISTS.AUTHOR_LIST"
              label="Author"
            />
          </v-row>
          <v-row>
            <DataList
              :item-model.sync="license_id"
              :type-object="$constants.DATA_LISTS.LICENSE_LIST"
              label="License"
            />
          </v-row>
          <v-row>
            <DataList
              :item-model.sync="image_source_id"
              :type-object="$constants.DATA_LISTS.IMAGE_SOURCE_LIST"
              label="Source"
            />
          </v-row>
          <v-row>
            <v-text-field
              v-model="url"
              label="Url"
            />
          </v-row>
          <v-row>
            <DataList
              :item-model.sync="order"
              :type-object="$constants.DATA_LISTS.MEDIA_PRIORITIES_LIST"
              label="Order"
            />
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="cancel"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="isDisabledAddButton"
          :loading="loading"
          color="blue darken-1"
          text
          @click="add(false)"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

import { mapActions } from 'vuex';
import DataList from '../DataLists/DataList.vue';

export default {
  name: 'ImageUploadDialog',
  components: { DataList },
  props: {
    objectId: {
      type: Number,
      default: null,
    },
    path: {
      type: String,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showDialog: false,
    file: null,
    author_id: null,
    license_id: null,
    image_source_id: null,
    url: '',
    order: 1,
    loading: false,
    disabled: false,
  }),
  created() {
    this.updateList({ ...this.$constants.DATA_LISTS.MEDIA_PRIORITIES_LIST, withOverlay: true });
  },
  methods: {
    ...mapActions({
      updateList: 'datalists/updateList',
    }),
    cancel() {
      this.showDialog = false;
      this.loading = false;
      this.file = null;
      this.author_id = null;
      this.license_id = null;
      this.image_source_id = null;
      this.url = null;
      this.disabled = false;
    },
    add() {
      if (!this.file) {
        return;
      }

      this.loading = true;
      this.disabled = true;

      const data = new FormData();
      data.append('image_file', this.file);
      data.append('object_id', `${this.objectId}`);
      if (this.author_id) {
        data.append('author_id', `${this.author_id}`);
      }
      if (this.license_id) {
        data.append('license_id', `${this.license_id}`);
      }
      if (this.image_source_id) {
        data.append('image_source_id', `${this.image_source_id}`);
      }
      data.append('url', `${this.url}`);
      data.append('order', `${this.order}`);

      this.$requestHelpers
        .post(`api/admin/${this.path}`,
          data,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
        .then((response) => {
          this.$emit('addNew', response, true);
        }).catch(() => {
          this.$emit('addNew', false);
        })
        .finally(() => {
          this.cancel();
        });
    },
  },

  computed: {
    isDisabledAddButton() {
      return !this.file;
    },
  },
};
</script>
